module.exports = __webpack_public_path__ + "img/icon-market-feed.f8dbdec4.png";